import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import {
  type ContactFormReqDto,
  FORMS_API_PATH_APPROVAL,
  FORMS_API_PATH_CONTACT,
  FORMS_API_PATH_NEWSLETTER_SUBSCRIPTION,
  type NewsletterSubscriptionReqDto,
} from '@pai/commons'
import { firstValueFrom, Observable, ReplaySubject, share } from 'rxjs'

import { LoggerService } from './logger/logger.service'

@Injectable({ providedIn: 'root' })
export class FormsApi {
  private readonly logger = inject(LoggerService).getInstance('FormsApiService')
  private readonly httpClient = inject(HttpClient)

  // it needs to be fresh. but we want to prevent simultaneous calls
  private _approvalToken$: Observable<string> | null = null
  get approvalToken$(): Observable<string> {
    return (this._approvalToken$ ??= this.getApprovalToken().pipe(
      share({
        connector: () => new ReplaySubject(1),
        resetOnError: true,
        resetOnRefCountZero: true,
        resetOnComplete: true,
      }),
    ))
  }

  readonly sendNewsletterSubscription = async (data: NewsletterSubscriptionReqDto): Promise<true> => {
    const req = this.httpClient.post(FORMS_API_PATH_NEWSLETTER_SUBSCRIPTION, JSON.stringify(data))
    const r = await firstValueFrom(req)
    this.logger.debug('newsletter-subscription', r)
    return true
  }

  readonly sendContactForm = async (data: ContactFormReqDto): Promise<true> => {
    const req = this.httpClient.post(FORMS_API_PATH_CONTACT, JSON.stringify(data))
    const r = await firstValueFrom(req)
    this.logger.debug('contact-form', r)
    return true
  }

  private getApprovalToken(): Observable<string> {
    return this.httpClient.get(FORMS_API_PATH_APPROVAL, { responseType: 'text' })
  }
}
